<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="position: relative;width: 90% !important;">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>
            <b-container fluid="">

                <button type="button" id="btn-flotante-aprobar" class="btn btn-sm btn-primary" @click="boton_aprobar"><i
                        class="fas fa-check"></i> Aprobar</button>
                <button type="button" id="btn-flotante-rechazar" class="btn btn-sm btn-danger"
                    @click="boton_rechazar"><i class="fas fa-ban"></i> Rechazar</button>

                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Aplicar descuento
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3 mb-2">
                        <div class="marco_detalle_pedidos">

                            <table class="table table-sm table-striped table-bordered" style="font-size: 13px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;text-align: center;">
                                            Código
                                        </th>
                                        <th style="width: 30%;">
                                            Nombre
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Cantidad
                                        </th>

                                        <th style="width: 10%;text-align: center;">
                                            Precio
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Sub Total
                                        </th>
                                        <!-- <th style="width: 10%;text-align: center;">
                                            P.Efectivo
                                        </th> -->
                                        <th style="width: 10%;text-align: center;">
                                            Descuento
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            Subtotal con descuento
                                        </th>
                                        <th style="width: 5%;text-align: center;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in listado_registros" :key="index">

                                        <td style="text-align: center;">
                                            {{ item.codigo }}
                                        </td>
                                        <td>
                                            {{ item.nombre_articulo }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ Math.abs(item.cantidad) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ item.precio.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ (Math.abs(item.cantidad) *
                                                item.precio).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }) }}
                                        </td>
                                        <!-- <td style="text-align: center;">
                                            Q{{ item.precio_efectivo.toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }) }}
                                        </td> -->

                                        <td style="text-align: center;">
                                            Q{{ (item.descuento).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            Q{{ ((Math.abs(item.cantidad) *
                                                item.precio) - item.descuento).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }) }}
                                        </td>
                                        <td style="text-align: center;">
                                            <button type="button" style="font-size: 9.5px;"
                                                class="btn btn-sm btn-outline-dark" @click="modificar_precio(item)"><i
                                                    class="fas fa-percent"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>

    </div>
</template>

<script>
    import { atexto, pregunta, texto } from '@/components/functions/alertas';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'DetalleSolicitud',
        computed: {
            ...mapState(['obj_solicitudes_descuento_admon', 'id_empresa_seleccionada'])
        },
        data() {
            return {
                listado_registros: []
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async obtener_registros() {
                // se obtienen los registros por el id de la solicitud
                let f = {
                    // api: `movimientos-detalles?filters[id_movimiento][$eq][0]=${this.obj_solicitudes_descuento_admon.id_documento}`
                    api: `movimientos-detalles/c/movimientos_por_id?idd=${this.obj_solicitudes_descuento_admon.id_documento}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                this.listado_registros = r

            },
            async modificar_precio(item) {
                texto({ titulo: 'Ingresa valor de descuento', input: 'number' }, async (i) => {

                    if (i) {

                        if (i <= 0) {
                            atexto({
                                titulo: 'Error!',
                                cuerpo: 'El descuento debe ser mayor a cero',
                                icono: 'error'
                            })
                        } else {
                            if (i >= (item.precio * Math.abs(item.cantidad))) {
                                atexto({
                                    titulo: 'Error!',
                                    cuerpo: 'El descuento debe ser menor al precio',
                                    icono: 'error'
                                })
                            } else {
                                let f = {
                                    api: `movimientos-detalles/c/aplicar-descuento?idd=${item.document_id}`,
                                    formulario: {
                                        descuento: parseFloat(i)
                                    }
                                }

                                await this.actualizar_data(f)
                                await this.obtener_registros()

                            }

                        }
                    }

                })

            },
            async boton_aprobar() {
                pregunta({ titulo: 'Deseas APROBAR este descuento?', texto: 'Quedará registro de esta acción', afirmacion: 'Si, aprobarlo!' }, async (i) => {

                    if (i) {
                        let f = {
                            api: `movimientos-detalles/a/cambiar-estado-solicitud-descuento?idd=${this.obj_solicitudes_descuento_admon.documentId}`,
                            formulario: {
                                estado: 'APROBADO'
                            }
                        }

                        await this.actualizar_data(f)
                        await this.$emit('actualizar_pendientes')
                        this.cerrar()

                    }
                })
            },
            async boton_rechazar() {
                pregunta({ titulo: 'Deseas RECHAZAR este descuento?', texto: 'Quedará registro de esta acción', afirmacion: 'Si, rechazarlo!' }, async (i) => {

                    if (i) {
                        let f = {
                            api: `solicitud-descuentos/rechazar/${this.obj_solicitudes_descuento_admon.documentId}`,
                            formulario: {
                                estado: 'RECHAZADO'
                            }
                        }

                        await this.actualizar_data(f)
                        await this.$emit('actualizar_pendientes')
                        this.cerrar()

                    }
                })
            },
            ...mapActions(['actualizar_data', 'obtener_data'])
        },
        mounted() {
            this.obtener_registros()
        },
    }
</script>

<style>

    .marco_detalle_pedidos {
        width: 100%;
        height: 400px;
        overflow: auto
    }

    #btn-flotante-aprobar {
        position: absolute;
        top: 60px;
        right: 120px;
        z-index: 999;
    }

    #btn-flotante-rechazar {
        position: absolute;
        top: 60px;
        right: 10px;
        z-index: 999;
    }
</style>